import React, { Component } from 'react';
import Tag from 'sushiweb/Tag';
import { Tooltip, Modal } from '../../../UiKit';
import { TagsDetails } from '../../popups';
import './Tags.scss';
import { sendEventToJumbo } from '../../../helpers/analytics';

export default class Tags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTagsPopup: false,
      uniqueTags: null,
    };
  }

  showTagsDetails = () => {
    sendEventToJumbo('tags_pop_show_event');
    this.setState({
      showTagsPopup: true,
    });
  };

  closePopup = () => {
    sendEventToJumbo('tags_pop_close_event');
    this.setState({
      showTagsPopup: false,
    });
  };

  getUniqueTags = () => {
    const { tags } = this.props;
    if (!tags) return null;
    const uniqueTags = Array.from(new Set(tags.map((a) => a.reason_id))).map(
      (reason_id) => {
        return tags.find((a) => a.reason_id === reason_id);
      },
    );
    return uniqueTags;
  };

  getTagTemplate = (tag, tagName) => {
    return (
      <React.Fragment>
        {tagName && (
          <span
            className='tagWrapper'
            style={{ display: 'flex', marginRight: '1rem' }}
            onClick={this.showTagsDetails}
          >
            <Tooltip
              position='bottom'
              border={false}
              title={
                <div className='tag'>
                  <Tag
                    type='tag'
                    label={tagName}
                    bgColor={tag.type === 'SYSTEM' ? '#F6F9FD' : '#F8F8F8'}
                    textColor={tag.type === 'SYSTEM' ? '#0366D6' : '#828282'}
                  />
                </div>
              }
              label='Click to view details'
            />
          </span>
        )}
      </React.Fragment>
    );
  };

  renderTags = () => {
    const uniqueTags = this.getUniqueTags();
    if (!uniqueTags) return null;
    const minTagsShows = uniqueTags.splice(0, 5);
    return (
      minTagsShows &&
      minTagsShows.map((tag, index) => {
        let tagName = tag.title ? tag.title : '';
        return (
          <React.Fragment key={index}>
            {this.getTagTemplate(tag, tagName)}
            {index === 4 && uniqueTags.length ? (
              <React.Fragment>
                {this.getTagTemplate(tag, `+${uniqueTags.length}`)}
              </React.Fragment>
            ) : null}
          </React.Fragment>
        );
      })
    );
  };

  render() {
    const { tags } = this.props;
    const { showTagsPopup } = this.state;
    if (!tags) return null;
    return (
      <React.Fragment>
        {this.renderTags()}
        <Modal
          isVisible={showTagsPopup}
          type='large'
          title='Tags Log'
          handleClose={this.closePopup.bind(this)}
          component={<TagsDetails tags={tags} />}
        />
      </React.Fragment>
    );
  }
}
